import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import {AuthService} from '../../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private auth: AuthService, private router: Router) {}

  async canActivate(): Promise<boolean | UrlTree> {
    // hasValidSession() tries a refresh before giving up — the access
    // token alone only lasts 30 minutes, so checking it in isolation would
    // log out a returning user who still has a perfectly good refresh
    // token (e.g. remember-me, or just back from a meeting).
    if (await this.auth.hasValidSession()) {
      return true;
    }

    this.auth.logout();
    return this.router.parseUrl('/landing');
  }
}
